import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, withLatestFrom} from "rxjs/operators";
import {INITIATE_PROCESS_ACTION, InitiateProcessActions} from "../actions/initiate-process-actions";
import {MatDialog} from "@angular/material/dialog";
import {
  FormProcessusDialogComponent
} from "../src/lib/components/form-processus-dialog/form-processus-dialog.component"; // Votre service pour gérer la conversion
import {Store} from '@ngrx/store';
import {AppStore, getCurrentFolder} from '@alfresco/aca-shared/store';

@Injectable()
export class InitiateProcessEffects {
  initiateProcess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<InitiateProcessActions>(INITIATE_PROCESS_ACTION),
        withLatestFrom(this.store.select(getCurrentFolder)),
        map(([action, currentFolder]) => {
          this.dialog.open(FormProcessusDialogComponent, {
            width: '1440px',
            data: {node: action.payload, currentFolder}
          })
        })
      ),
    {dispatch: false}
  );

  constructor(
    private actions$: Actions,
    private dialog: MatDialog,
    private store: Store<AppStore>
  ) {
  }
}
